import React, { useEffect, useState } from 'react';
import './printOptionsModal.css';

const printOptions = [
  {
    key: 'qrcode',
    title: 'QR Code',
    description: 'Print QR labels for the garments in this order',
    icon: 'bi-qr-code',
    tone: 'blue',
  },
  {
    key: 'customerCopy',
    title: 'Customer Copy',
    description: 'Print the order receipt for the customer',
    icon: 'bi-receipt-cutoff',
    tone: 'green',
  },
  {
    key: 'measurements',
    title: 'Measurements',
    description: 'Print the customer measurement sheet',
    icon: 'bi-rulers',
    tone: 'amber',
  },
];

const PrintOptionsModal = ({ isOpen, onClose, onPrint, previews = {} }) => {
  const [activeOption, setActiveOption] = useState('qrcode');

  useEffect(() => {
    if (isOpen) setActiveOption('qrcode');
  }, [isOpen]);

  if (!isOpen) return null;

  const selectedOption =
    printOptions.find((option) => option.key === activeOption) || printOptions[0];

  return (
    <div
      className="print-choice-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="print-options-title"
    >
      <div className="print-choice-modal">
        <header className="print-choice-header">
          <div>
            <span className="print-choice-eyebrow">ORDER SAVED</span>
            <h2 id="print-options-title">Print preview</h2>
            <p>Select a tab, review the document, then print it.</p>
          </div>
          <button type="button" onClick={onClose} aria-label="Close print options">
            <i className="bi bi-x-lg" />
          </button>
        </header>

        <div className="print-choice-tabs" role="tablist" aria-label="Print type">
          {printOptions.map((option) => (
            <button
              type="button"
              key={option.key}
              role="tab"
              aria-selected={activeOption === option.key}
              className={`print-choice-tab print-choice-tab--${option.tone} ${
                activeOption === option.key ? 'is-active' : ''
              }`}
              onClick={() => setActiveOption(option.key)}
            >
              <span className="print-choice-tab__icon" aria-hidden="true">
                <i className={`bi ${option.icon}`} />
              </span>
              <strong>{option.title}</strong>
            </button>
          ))}
        </div>

        <section
          className={`print-choice-preview print-choice-preview--${selectedOption.tone}`}
          role="tabpanel"
        >
          <div className="print-choice-preview__top">
            <div>
              <span>SELECTED PRINT</span>
              <h3>{selectedOption.title}</h3>
              <p>{selectedOption.description}</p>
            </div>
            <i className={`bi ${selectedOption.icon}`} aria-hidden="true" />
          </div>

          <div className={`print-choice-preview__canvas is-${activeOption}`}>
            <div className="print-choice-preview__paper">
              {previews[activeOption] || (
                <div className="print-choice-preview__empty">
                  <i className={`bi ${selectedOption.icon}`} />
                  Preparing preview
                </div>
              )}
            </div>
          </div>

          <button
            type="button"
            className="print-choice-preview__print"
            onClick={() => onPrint(activeOption)}
          >
            <i className="bi bi-printer" />
            Print {selectedOption.title}
          </button>
        </section>

        <div className="print-choice-tip">
          <i className="bi bi-info-circle" />
          This screen will remain open after you close the print window.
        </div>

        <footer className="print-choice-footer">
          <button type="button" onClick={onClose}>
            Printing complete
          </button>
        </footer>
      </div>
    </div>
  );
};

export default PrintOptionsModal;
